import { css, cx } from '@portal/styled-system/css'

import { isTermsAccepted } from '@/features/terms'
import { useI18n } from '@/shared/lib/i18n'

type FacebookButtonProps = {
    onClick: () => void
    onTermsNotAccepted: () => void
}

export function FacebookButton(props: FacebookButtonProps) {
    const { i18n } = useI18n()

    const handleClick = () => {
        if (isTermsAccepted()) {
            props.onClick()
        } else {
            props.onTermsNotAccepted()
        }
    }

    return (
        <button
            className={css({
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                width: 'full',
                height: '[40px]',
                color: 'fb.light',
                borderWidth: 'sm',
                borderRadius: 'small',
                borderStyle: 'solid', // reset
                borderColor: 'fb.light',
                backgroundColor: 'white',
                fontFamily: 'montserrat',
                _hover: { backgroundColor: 'fb.light', color: 'white' },
                _active: { backgroundColor: 'fb.active', color: 'white' },
                _focusVisible: {
                    boxShadow: '[0 0 0 0.25rem var(--shadow-color)]',
                    boxShadowColor: 'fb.light/25',
                },
            })}
            onClick={handleClick}
            aria-hidden="true"
        >
            <i className={cx('fa-brands fa-facebook', css({ fontSize: '2xl', paddingLeft: '[14px]' }))} />
            <div className={css({ margin: 'auto', fontSize: '[13px]', paddingRight: '[14px]' })}>
                {i18n.LANDING_FB_BUTTON_CONTINUE}
            </div>
        </button>
    )
}
